import { render, staticRenderFns } from "./frameSystem.vue?vue&type=template&id=474037e7&"
import script from "./frameSystem.vue?vue&type=script&lang=js&"
export * from "./frameSystem.vue?vue&type=script&lang=js&"
import style0 from "./frameSystem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports